import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from '~/i18n'
import Column from '~/Common-Objects/Grids/Column/Column'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import SnackBar from '~/Common-Objects/UI/Notifications/SnackBar/SnackBar'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import AceEditor from 'react-ace'
import 'brace/mode/html'
import copy from 'copy-to-clipboard'
import axios from '~/data/http/axios'

const inline = `<script>
var mpEmailAddress = "test@test.com";
var mpGroupId = 74175;
var mpPath = "/path.html"
var mpQuery = "?query=1"
var mpCustomFields = {
    "First Name": "Colin",
    "Age": 19,
    "Birthdate": new Date("2015-03-25").toISOString(),
    "Male: true
}
//Event Tracking (Optional)
var mpEventName = "my event name"
var mpEventData = {"myCustom":"dataHere"}
</script>`

const programatically = `<script>
manualTracking(
    mpPath,
    mpQuery,
    mpEmailAddress,
    mpCustomFields,
    mpGroupId,
    mpEventName, 
    mpEventData
)
</script>`

@connect((store) => {
    return { site: store.siteMaster, account: store.accountMaster }
})
class SiteTrackingAdvanced extends Component {
    constructor(props) {
        super(props)
        this.state = {
            alertOpen: '',
            alertMessage: '',
            apiDoc: {},
            pageLoaded: false,
            apiPostTable: [],
            apiResponseTable: []
        }
        this.getApiDocs = this.getApiDocs.bind(this)
        this.copyToClipboard = this.copyToClipboard.bind(this)
    }

    componentDidMount() {
        this.getApiDocs()
    }
    async getApiDocs() {
        let apiDoc = await axios.get('/api/apiDoc/122')
        apiDoc = apiDoc.data.ApiDocs

        let apiPostTable = JSON.parse(apiDoc.postData).map((row) => {
            return [
                {
                    headerValue: '',
                    value: row.fieldName
                },
                {
                    headerValue: '',
                    value: row.required ? <SquareChip value='Required' className='square-chip-red' /> : ''
                },
                {
                    headerValue: '',
                    value: row.dataType
                },
                {
                    headerValue: '',
                    value: row.description
                }
            ]
        })
        let apiResponseTable = JSON.parse(apiDoc.responseData).map((row) => {
            return [
                {
                    headerValue: '',
                    value: row.fieldName
                },
                {
                    headerValue: '',
                    value: row.dataType
                },
                {
                    headerValue: '',
                    value: row.description
                }
            ]
        })
        this.setState({ apiDoc, pageLoaded: true, apiPostTable, apiResponseTable })
    }
    copyToClipboard(key) {
        this.setState({
            alertOpen: true,
            alertMessage: i18n.t('campaigns:sitetracking.trackingsites.copiedToClipboard')
        })
        copy(this.props.embedCode)
    }

    render() {
        if (!this.state.pageLoaded) return <LoadingIcons iconType='2' />
        return (
            <>
                <Row className='mar-b25'>
                    <Column xs={12} sm={8}>
                        <Paper style={{ height: '100%' }}>
                            <h4 className='mar-b10'>Advanced</h4>
                            <div className='mar-b10'>
                                Advanced options for pushing events and custom site tracking information via code.
                            </div>
                            <div>
                                Use either the Javascript code samples to push extra data or trigger events client side,
                                or use the API to send data backend.
                            </div>
                        </Paper>
                    </Column>
                    <Column xs={12} sm={4}>
                        <Paper className='mar-b0 text-center'>
                            <h4 className='mar-b10'>Site Tracking Javascript</h4>
                            <div className='mar-b10'>Deploy this anywhere where you would like to track visitors</div>
                            <TextInput
                                value={this.props.embedCode}
                                className='txtInput'
                                iconRight={
                                    <Icons
                                        icon='copyClipboard'
                                        onClick={() => {
                                            this.copyToClipboard()
                                        }}
                                    />
                                }
                                readOnly={true}
                            />
                        </Paper>
                    </Column>
                </Row>

                <Row>
                    <Column xs={12} sm={6}>
                        <Paper>
                            <h4 className='mar-b25'>Javascript</h4>
                            <div>{i18n.t('campaigns:sitetracking.trackingsites.moreOptionsDesc')}</div>
                            {this.props.site && this.props.site.siteId == 1 && (
                                <div>
                                    Find out more about advanced web tracking options and how you can use them by{' '}
                                    <a
                                        href='https://transpond.io/support/growing-your-audience/website-tracking'
                                        target='_blank'
                                    >
                                        clicking here
                                    </a>
                                    .
                                </div>
                            )}

                            <h4 className='mar-b15 mar-t15'>
                                {i18n.t('campaigns:sitetracking.trackingsites.availableOptions')}
                            </h4>
                            <Paper>
                                <table width='100%' cellPadding='10' cellSpacing='0' className='mar-b25'>
                                    <tr>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            <SquareChip>mpEmailAddress</SquareChip>
                                        </td>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            {i18n.t(
                                                'campaigns:sitetracking.trackingsites.availableOpts.mpEmailAddress'
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            <SquareChip>mpGroupId</SquareChip>
                                        </td>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            {i18n.t('campaigns:sitetracking.trackingsites.availableOpts.mpGroupId')}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            <SquareChip>mpPath</SquareChip>
                                        </td>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            {i18n.t('campaigns:sitetracking.trackingsites.availableOpts.mpPath')}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            <SquareChip>mpQuery</SquareChip>
                                        </td>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            {i18n.t('campaigns:sitetracking.trackingsites.availableOpts.mpQuery')}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            <SquareChip>mpCustomFields</SquareChip>
                                        </td>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            {i18n.t(
                                                'campaigns:sitetracking.trackingsites.availableOpts.mpCustomFields'
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            <SquareChip>mpEventName</SquareChip>
                                        </td>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            {i18n.t('campaigns:sitetracking.trackingsites.availableOpts.mpEventName')}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            <SquareChip>mpEventData</SquareChip>
                                        </td>
                                        <td className='text-sml' style={{ verticalAlign: 'top' }}>
                                            {i18n.t('campaigns:sitetracking.trackingsites.availableOpts.mpEventData')}
                                        </td>
                                    </tr>
                                </table>
                            </Paper>

                            <h4 className='mar-b15'>Code Samples</h4>

                            <Paper>
                                <h4 className='mar-b15'>
                                    {i18n.t('campaigns:sitetracking.trackingsites.inlineVariables')}
                                </h4>
                                <div className='mar-b15'>
                                    {i18n.t('campaigns:sitetracking.trackingsites.inlineVariablesDesc')}
                                </div>
                                <Paper className='mar-b0' style={{ padding: 0 }}>
                                    <AceEditor
                                        height={240}
                                        mode={'html'}
                                        theme='xcode'
                                        name='code'
                                        width='100%'
                                        readOnly={true}
                                        wrapEnabled={true}
                                        showPrintMargin={false}
                                        editorProps={{ $blockScrolling: true }}
                                        value={inline}
                                    />
                                </Paper>
                            </Paper>

                            <Paper>
                                <h4 className='mar-b15'>
                                    {i18n.t('campaigns:sitetracking.trackingsites.functionVariables')}
                                </h4>
                                <div className='mar-b15'>
                                    {i18n.t('campaigns:sitetracking.trackingsites.functionVariablesDesc')}
                                </div>
                                <Paper className='mar-b0' style={{ padding: 0 }}>
                                    <AceEditor
                                        height={180}
                                        mode={'html'}
                                        theme='xcode'
                                        name='code'
                                        width='100%'
                                        readOnly={true}
                                        wrapEnabled={true}
                                        showPrintMargin={false}
                                        editorProps={{ $blockScrolling: true }}
                                        value={programatically}
                                    />
                                </Paper>
                            </Paper>
                        </Paper>
                    </Column>
                    <Column xs={12} sm={6}>
                        <Paper>
                            <h4 className='mar-b25'>API</h4>
                            <div
                                className='mar-b15'
                                dangerouslySetInnerHTML={{ __html: this.state.apiDoc.headerDescription }}
                            />
                            <hr />
                            <div className='text-heavy mar-b10'>Request</div>
                            <div className='mar-b15'>
                                Send a <strong>POST</strong> to the api endpoint
                            </div>
                            <hr />
                            <div className='text-heavy mar-b10'>Api Endpoint</div>
                            <Paper style={{ padding: '15px' }}>
                                {'https://' + this.props.site.trackingDomain + this.state.apiDoc.requestUrl}
                            </Paper>
                            <hr />
                            <div className='text-heavy mar-b10'>Request</div>
                            <Paper style={{ padding: 15 }}>
                                <DataTable1
                                    noResultsTxt={''}
                                    tableData={this.state.apiPostTable}
                                    dataUpdater={() => {}}
                                    width='100%'
                                    pageSize='100'
                                    hasCheckBoxes='no'
                                    sortedColumn={''}
                                    sortedDirection={''}
                                    loadingData={false}
                                />
                            </Paper>
                            <hr />
                            <div className='text-heavy mar-b10'>Response</div>
                            <Paper style={{ padding: 15 }}>
                                <DataTable1
                                    noResultsTxt={''}
                                    tableData={this.state.apiResponseTable}
                                    dataUpdater={() => {}}
                                    width='100%'
                                    pageSize='100'
                                    hasCheckBoxes='no'
                                    sortedColumn={''}
                                    sortedDirection={''}
                                    loadingData={false}
                                />
                            </Paper>
                            <hr />
                            <div className='text-heavy mar-b10'>Sample Request</div>
                            <Paper style={{ padding: 0 }}>
                                <AceEditor
                                    height={100}
                                    mode={'json'}
                                    theme='xcode'
                                    name='code'
                                    width='100%'
                                    readOnly={true}
                                    wrapEnabled={true}
                                    showPrintMargin={false}
                                    editorProps={{ $blockScrolling: true }}
                                    value={JSON.stringify(JSON.parse(this.state.apiDoc.requestExample), null, 2)}
                                />
                            </Paper>

                            <hr />
                            <div className='text-heavy mar-b10'>Sample Response</div>
                            <Paper className='mar-b0' style={{ padding: 0 }}>
                                <AceEditor
                                    height={100}
                                    mode={'json'}
                                    theme='xcode'
                                    name='code'
                                    width='100%'
                                    readOnly={true}
                                    wrapEnabled={true}
                                    showPrintMargin={false}
                                    editorProps={{ $blockScrolling: true }}
                                    value={JSON.stringify(JSON.parse(this.state.apiDoc.responseExample), null, 2)}
                                />
                            </Paper>
                        </Paper>
                    </Column>
                </Row>
                <SnackBar
                    message={this.state.alertMessage}
                    open={this.state.alertOpen}
                    autoclose={true}
                    dismiss={() => this.setState({ alertOpen: false })}
                />
            </>
        )
    }
}

export default SiteTrackingAdvanced
